// Tooltip.jsx
import React, { useState } from "react";

const Tooltip = ({ content, children, className = "" }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {children}
            <div
                role="tooltip"
                className={`absolute z-20 px-3 py-2 min-w-[160px] bg-gray-800 text-white rounded-lg shadow-lg transition-opacity duration-200 ${visible ? "opacity-100" : "opacity-0 pointer-events-none"
                    } bottom-full mb-2 left-1/2 transform -translate-x-1/2 ${className}`}
            >
                {content}
                {/* Tooltip Arrow */}
                <div className="absolute top-full left-1/2 w-2 h-2 -translate-x-1/2 overflow-hidden">
                    <div className="w-2 h-2 bg-gray-800 rotate-45 transform origin-bottom-left -translate-y-1" />
                </div>
            </div>
        </div>
    );
};

export default Tooltip;